import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IOnCampusBuilding } from 'app/models/licenses/hospital/on-campus-building';

@Injectable({providedIn: 'root'})

export class OnCampusBuildingService {
  private api: string = environment.privateApi + 'OnCampusBuilding/';
  private http = inject(HttpClient);

  public getBuildings(entityId: number, entityType: string, includeArchived: boolean): Observable<IOnCampusBuilding[]>{
    return this.http.get<IOnCampusBuilding[]>(this.api + 'GetOnCampusBuildings/' + entityId + '/' + entityType + '/' + includeArchived);
  }

  public createBuilding(building: IOnCampusBuilding, entityId: number, entityType: string): Observable<IOnCampusBuilding>{
    return this.http.post<IOnCampusBuilding>(this.api + 'CreateOnCampusBuilding/' + entityId + '/' + entityType, building);
  }

  public updateOnCampusBuilding(building: IOnCampusBuilding): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'UpdateOnCampusBuilding', building);
  }

  public archiveOnCampusBuilding(buildingId: number, archive: boolean): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'ArchiveOnCampusBuilding/' + buildingId + '/' + archive, null);
  }

  public deleteOnCampusBuilding(buildingId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'DeleteOnCampusBuilding/' + buildingId);
  }
}
